import { useState } from 'react';
import { useMutation } from '@apollo/client';
import AddIcon from '@mui/icons-material/Add';
import useAlertPageAlerts from 'components/alerts/useAlertPageAlerts';
import SaveAlertDialog from 'components/alerts/SaveAlertDialog';
import { ALERTS_QUERY, CREATE_ALERT } from 'components/alerts/queries';
import Button from 'components/common/Button/Button';
import { AlertInput } from 'common/graphqlTypes';
import ELEMENT from 'common/element';

function AddAlertButton(): JSX.Element {
  const [showAddAlertDialog, setShowAddAlertDialog] = useState(false);
  const alertPageAlerts = useAlertPageAlerts();
  const refetchQueries = [{ query: ALERTS_QUERY }];
  const [createAlert] = useMutation(CREATE_ALERT, { refetchQueries });

  const openAddAlertDialog = (): void => {
    setShowAddAlertDialog(true);
  };

  const closeAddAlertDialog = (): void => {
    setShowAddAlertDialog(false);
  };

  const handleAddAlert = (alertToSave: AlertInput): void => {
    createAlert({ variables: { alert: alertToSave } })
      .then(closeAddAlertDialog)
      .then(alertPageAlerts.showUpdateSuccess)
      .catch(alertPageAlerts.showError);
  };

  return (
    <div className="AddAlertButton">
      <Button
        onClick={openAddAlertDialog}
        leftIcon={<AddIcon fontSize="small" />}
        size="sm"
        testId={ELEMENT.alertAddAlertButton}
      >
        Add Alert
      </Button>

      <SaveAlertDialog
        title="Add Alert"
        show={showAddAlertDialog}
        close={closeAddAlertDialog}
        handleSubmit={handleAddAlert}
      />
    </div>
  );
}

export default AddAlertButton;
